import React from 'react';
import { formatDateTime } from '../../../utils/formatting';
import styles from '../../../pages/Fup/Fup.module.css';

interface PublicFormAnsweredStateProps {
  title: string;
  thankYouMessage: string;
  answeredAt?: string | null;
}

const PublicFormAnsweredState: React.FC<PublicFormAnsweredStateProps> = ({
  title,
  thankYouMessage,
  answeredAt,
}) => (
  <div className={styles.answeredBanner}>
    <p className={styles.answeredTitle}>{title}</p>
    <p className={styles.answeredMeta}>{thankYouMessage}</p>
    {answeredAt && (
      <p className={styles.answeredMeta}>
        <span className={styles.answeredMetaLabel}>Data da resposta:</span>
        {formatDateTime(answeredAt)}
      </p>
    )}
  </div>
);

export default PublicFormAnsweredState;
